import { paths } from '@cms/routes'
import queryString from 'query-string'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const useSelectedMenuItems = () => {
  const { pathname, search } = useLocation()
  const searchParam = queryString.parse(search)
  const currentPath = pathname.split('/').filter(Boolean)

  return useMemo(() => {
    const lastPath = currentPath.at(-1)

    if (
      (pathname.includes(paths.contentTypes.root) ||
        pathname.includes(paths.content.root)) &&
      searchParam?.type
    ) {
      if (Array.isArray(searchParam.type)) {
        return searchParam.type[0] ?? ''
      }

      return searchParam.type
    }

    return lastPath ?? paths.contentTypes.root
  }, [pathname, searchParam, currentPath])
}
